<div class="carlist-layout" dir="rtl">
  <!-- ========== قیلتر ========== -->
  <app-filter-panel
    [open]="isFilterPanelOpen"
    [options]="filterOptions"
    [groupCounts]="filterGroupCounts"
    [appliedValue]="appliedFilterValue"
    (apply)="onFilterApply($event)"
    (closed)="onFilterClosed()">
  </app-filter-panel>
  <!-- ========== محتوای اصلی ========== -->
  <main class="app-main">
    <div class="app-container">
      <div class="card-panel card-toolbar">
        <div class="action-bar">
          <div class="action-group">
            <button
              class="btn btn-light-icon btn-sm"
              [routerLink]="['/']"
              title="بازگشت"
            >
              <i class="fa fa-arrow-right"></i>
            </button>
            <button
              class="btn btn-accent btn-sm"
              (click)="toggleFilterPanel()"
            >
              <i class="fa fa-filter"></i> فیلتر
              <span class="filter-badge" *ngIf="activeFilterCount > 0">{{
                activeFilterCount | faNum
              }}</span>
            </button>
            <button
              class="btn btn-accent btn-sm"
              (click)="exportExcel('excel-car-list')"
            >
              <i class="fa fa-file-excel-o"></i> اکسل
            </button>
            <button
              *ngIf="canEditCars"
              class="btn btn-outline-secondary btn-sm"
              (click)="updateServiceArea()"
            >
              <i class="fa fa-map-marker"></i> حوزه خدمتی
            </button>
            <button
              *ngIf="canSendSms"
              class="btn btn-outline-secondary btn-sm"
              (click)="openSmsModal()"
            >
              <i class="fa fa-comment"></i> فرمان به دستگاه
            </button>
            <button
              *ngIf="canSendPush"
              class="btn btn-outline-secondary btn-sm"
              (click)="openPushModal()"
            >
              <i class="fa fa-bell"></i> پیام به راننده
            </button>
            <button
              class="btn btn-outline-secondary btn-sm"
              (click)="showAllOnMap()"
            >
              <i class="fa fa-map"></i> نمایش
            </button>
            <button
              *ngIf="canUpdateValidity"
              class="btn btn-outline-secondary btn-sm"
              (click)="openValidityModal()"
            >
              <i class="fa fa-credit-card"></i> ویرایش اعتبار
            </button>
          </div>
          <div class="live-counter">
            <i class="fa fa-car"></i> تعداد متحرک:
            <span>{{ carCount | faNum }}</span> مورد
          </div>
        </div>
        <div class="quick-search" [formGroup]="quickSearchForm">
          <i class="fa fa-search"></i>
          <input
            formControlName="txt"
            placeholder="بر اساس نام راننده / حوزه خدمت / IMEI / شماره پرسنلی / پلاک / سیمکارت ردیاب جستجو کنید ..."
            (input)="quickSearch()"
          />
        </div>
      </div>
      <div class="card-panel card-table">
        <!-- حالت موبایل -->
        <div class="mobile-cards" *ngIf="!isDesktop">
          <div
            class="vehicle-card-mobile"
            *ngFor="let item of visibleCars"
            [routerLink]="['/carInfo/', item.strUnitID]"
          >
            <div class="mobile-row">
              <span
                ><span
                  class="online-dot"
                  [class.offline]="!item.bOnline"
                ></span>
                {{ item.bOnline ? "آنلاین" : "آفلاین" }}</span
              >
              <span class="speed-tag">{{ item.iSpeed }} km/h</span>
            </div>
            <div class="mobile-row">
              <span class="driver-name">{{
                item.strFullName2 || item.strFullName
              }}</span>
              <i
                class="fa fa-car"
                style="color: var(--primary-light); font-size: 18px"
              ></i>
            </div>
            <div class="mobile-row">
              <span class="plate-badge">{{ item.strVehicleNo }}</span>
              <span class="text-muted-light"
                >{{ item.strDate | faNum }} - {{ item.strTime | faNum }}</span
              >
            </div>
          </div>
          <div *ngIf="!visibleCars?.length" class="empty-state">
            <i class="fa fa-car"></i>
            <p *ngIf="activeFilterCount > 0">
              با این فیلترها خودرویی پیدا نشد!
            </p>
            <p *ngIf="activeFilterCount > 0" class="text-muted-light">
              فیلترها را تغییر دهید و دوباره جستجو کنید.
            </p>
            <button
              *ngIf="activeFilterCount > 0"
              class="btn btn-accent btn-sm"
              (click)="openFilterPanel()"
            >
              <i class="fa fa-filter"></i> تغییر فیلتر
            </button>
            <p *ngIf="activeFilterCount === 0">خودرویی موجود نیست!</p>
          </div>
        </div>
        <!-- جدول دسکتاپ -->
        <div class="table-responsive" #scrollContainer *ngIf="isDesktop">
          <table class="vehicles-table" id="excel-car-list">
            <thead>
              <tr>
                <th>#</th>
                <th *ngIf="isTaxiLon">عملیات</th>
                <th *ngIf="canEditCars">
                  <input
                    type="checkbox"
                    class="row-checkbox"
                    [checked]="allSelected"
                    (click)="toggleSelectAllCars()"
                  />
                </th>
                <th>وضعیت</th>
                <th>فعال</th>
                <th class="sortable" (click)="sortBy(1)">
                  راننده <i class="fa fa-sort"></i>
                </th>
                <th>شماره</th>
                <th>VIN</th>
                <th>تیپ</th>
                <th>پلاک</th>
                <th>IMEI</th>
                <th class="sortable" (click)="sortBy(3)">
                  پایان اعتبار <i class="fa fa-sort"></i>
                </th>
                <th class="sortable" (click)="sortBy(5)">
                  آخرین سابقه <i class="fa fa-sort"></i>
                </th>
                <th>موبایل راننده</th>
                <th class="sortable" (click)="sortBy(4)">
                  حوزه خدمت <i class="fa fa-sort"></i>
                </th>
                <th>نوع</th>
                <th>سیم‌کارت</th>
                <th class="sortable" (click)="sortBy(0)">
                  پرسنلی/شناسه <i class="fa fa-sort"></i>
                </th>
                <th class="sortable" (click)="sortBy(2)">
                  تاریخ ثبت <i class="fa fa-sort"></i>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                *ngFor="let item of visibleCars; let i = index"
                (click)="openCarDetails(item)"
                [class.selected]="item?.bChosen"
              >
                <td>{{ i + 1 | faNum }}</td>
                <td *ngIf="isTaxiLon">
                  <i
                    class="fa fa-calendar action-icon"
                    title="برنامه راننده"
                    (click)="openDriverSchedule($event, item)"
                  ></i>
                </td>
                <td *ngIf="canEditCars">
                  <input
                    type="checkbox"
                    class="row-checkbox"
                    [checked]="item?.bChosen"
                    (click)="onCarCheckbox($event, i)"
                  />
                </td>
                <td>
                  <span class="status-badge" [class.offline]="!item.bOnline"
                    ><i class="fa fa-circle"></i>
                    {{ item.bOnline ? "آنلاین" : "آفلاین" }}</span
                  >
                </td>
                <td>
                  <span
                    [class]="item.bActive ? 'active-badge' : 'inactive-badge'"
                    >{{ item.bActive ? "فعال" : "غیرفعال" }}</span
                  >
                </td>
                <td>{{ item.strFullName2 }}</td>
                <td>{{ item.iCode | faNum }}</td>
                <td>{{ item.strVIN | faNum }}</td>
                <td>{{ item.strVehicleType }}</td>
                <td>
                  {{
                    item.strVehicleNo
                      ? otherService.returnCorrectPlate(item.strVehicleNo)
                      : ("" | faNum)
                  }}
                </td>
                <td>{{ item.strUnitID | faNum }}</td>
                <td>{{ item.strValidDate | faNum }}</td>
                <td>
                  {{ item.strTime | faNum }} - {{ item.strDate | faNum }}
                </td>
                <td>{{ item.strMobile | faNum }}</td>
                <td>{{ item.strMobileDomain_strComment }}</td>
                <td>{{ item.strMobileType_strComment }}</td>
                <td>{{ item.strCellNo | faNum }}</td>
                <td>{{ item.strPersonnelID | faNum }}</td>
                <td>{{ item.strDefinationDate | faNum }}</td>
              </tr>
            </tbody>
          </table>
          <div *ngIf="visibleCars?.length === 0" class="empty-state">
            <i class="fa fa-car"></i>
            <p *ngIf="activeFilterCount > 0">
              با این فیلترها خودرویی پیدا نشد!
            </p>
            <p *ngIf="activeFilterCount > 0" class="text-muted-light">
              فیلترها را تغییر دهید و دوباره جستجو کنید.
            </p>
            <button
              *ngIf="activeFilterCount > 0"
              class="btn btn-accent btn-sm"
              (click)="openFilterPanel()"
            >
              <i class="fa fa-filter"></i> تغییر فیلتر
            </button>
            <p *ngIf="activeFilterCount === 0">خودرویی موجود نیست!</p>
          </div>
        </div>
      </div>
    </div>
  </main>
</div>

<app-sms-modal></app-sms-modal>
<app-push-modal [canSendPayamak]="canSendPayamak"></app-push-modal>
<app-assign-modal></app-assign-modal>
<app-validity-modal></app-validity-modal>
